export default "__VITE_ASSET__CANJuH4z__$_?url__"